// Materials flagged `circularity_locked` by the API (paints and coatings, reagents) keep their
// default or AI-suggested circularity values, which still feed MCI and PCI, but users cannot edit them.

export const isCircularityLocked = (item) => item?.circularity_locked === true;

/** AG Grid `editable` callback: locked rows and pinned rows are read-only. */
export const isCircularityRowEditable = (params) => !params.node?.rowPinned && !isCircularityLocked(params.data);
